import { flexRender, type HeaderGroup, type RowData, type TableFeatures } from '@tanstack/react-table';
import { column_getCanSort, column_getIsSorted, column_toggleSorting } from '@tanstack/react-table/static-functions';
import { SortableHeaderCell, Table } from '..';
export interface TrHeaderGroupProps<TFeatures extends TableFeatures, T extends RowData> {
  headerGroup: HeaderGroup<TFeatures, T>;
  columnLabels?: Record<string, string>;
}
export function TrHeaderGroup<TFeatures extends TableFeatures, T extends RowData>({
  headerGroup,
  columnLabels
}: TrHeaderGroupProps<TFeatures, T>) {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  return <Table.Tr>
      {headerGroup.headers.map(header => <SortableHeaderCell key={header.id} colSpan={header.colSpan}
    // oxlint-disable-next-line typescript/consistent-type-assertions
    columnName={columnLabels?.[header.id as keyof typeof columnLabels]} isSorted={column_getIsSorted(header.column)} isSortable={column_getCanSort(header.column)} onClick={() => {
      if (column_getCanSort(header.column)) column_toggleSorting(header.column);
    }}>
          {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
        </SortableHeaderCell>)}
    </Table.Tr>;
}